export default __webpack_public_path__ + "static/media/alfAward.f2503fef.jpg";